module.exports = __webpack_public_path__ + "static/media/logo-footer.67b8c133.svg";